import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from '../shared/services/apiService.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { CanonicalService } from '../shared/seo/canonical.service';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { RootService } from '../shared/services/root.service';
import { Router } from '@angular/router';
import { SeoService } from '../shared/seo/seo.service';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss']
})

export class SitemapComponent implements OnInit,OnDestroy {
  sub: Subscription = new Subscription();
  productdetails_data: any;
  productlist_data: any;
  baseurl: any;
  filterProductList: any;
  buses: any;
  scvpickups: any;
  trucks:any = [];
  productUrls: any = []
  TruckList: any;
  BusesList: any;
  SCVList: any;
  Menu: any;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  metatitle: any = "Buy Tata Trucks and Buses Online - Sitemap";
  metadesc: any="Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.";

  constructor(
    private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: Object, private localStorage:secureStorage,
    private canonicalservice: CanonicalService,
    private cleverService: ClevertapService,
    private storageService: RootService,
    private router: Router,

    private seoservice: SeoService,
  ) { }
  ngOnInit() {
    this.seo();
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Sitemap");
      } catch { }
    }
    this.canonicalservice.createCanonicalURL('');
    this.getMenu();
    this.breadcrumb();
    if (isPlatformBrowser(this.platformId)) {
      this.baseurl = environment.baseUrl;
    }
  }
  getMenu() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('menuItem') && localStorage.getItem('menuItem').includes('data')) {
        let response = JSON.parse(localStorage.getItem('menuItem'));
        this.Menu = response.data;
          this.TruckList = {
            keys: Object.keys(this.Menu.trucks),
            values: Object.values(this.Menu.trucks),
            data: []
          }
          this.BusesList = {
            keys: Object.keys(this.Menu.buses),
            values: Object.values(this.Menu.buses),
            data: []
          }
          this.SCVList = {
            keys: Object.keys(this.Menu.SCVPickups),
            values: Object.values(this.Menu.SCVPickups),
            data: []
          }

          for (let i = 0; i < this.TruckList.keys.length; i++) {
            let data = { name: this.TruckList.keys[i], link: this.TruckList.values[i].footerLink[0].name, ppl: this.TruckList.values[i].ppl_list}
            this.TruckList.data.push(data)
          }
          for (let i = 0; i < this.BusesList.keys.length; i++) {
            let data = { name: this.BusesList.keys[i], link: this.BusesList.values[i].footerLink[0].name, ppl: this.BusesList.values[i].ppl_list }
            this.BusesList.data.push(data)
          }
          for (let i = 0; i < this.SCVList.keys.length; i++) {
            let data = { name: this.SCVList.keys[i], link: this.SCVList.values[i].footerLink[0].name, ppl: this.SCVList.values[i].ppl_list }
            this.SCVList.data.push(data)
          }
      }
      else{
        this.sub.add(this.apiService.getMenuItemList()
          .subscribe({
            next: (response: any) => {
              localStorage.setItem('menuItem',JSON.stringify(response));
              this.Menu = response.data;
              this.TruckList = {
                keys: Object.keys(this.Menu.trucks),
                values: Object.values(this.Menu.trucks),
                data: []
              }
              this.BusesList = {
                keys: Object.keys(this.Menu.buses),
                values: Object.values(this.Menu.buses),
                data: []
              }
              this.SCVList = {
                keys: Object.keys(this.Menu.SCVPickups),
                values: Object.values(this.Menu.SCVPickups),
                data: []
              }
              for (let i = 0; i < this.TruckList.keys.length; i++) {
                let data = { name: this.TruckList.keys[i], link: this.TruckList.values[i].footerLink[0].name, ppl: this.TruckList.values[i].ppl_list}
                this.TruckList.data.push(data)
              }
              for (let i = 0; i < this.BusesList.keys.length; i++) {
                let data = { name: this.BusesList.keys[i], link: this.BusesList.values[i].footerLink[0].name, ppl: this.BusesList.values[i].ppl_list }
                this.BusesList.data.push(data)
              }
              for (let i = 0; i < this.SCVList.keys.length; i++) {
                let data = { name: this.SCVList.keys[i], link: this.SCVList.values[i].footerLink[0].name, ppl: this.SCVList.values[i].ppl_list }
                this.SCVList.data.push(data)
              }


            },
            error: () => { },
            complete: () => { }

          })
        )
      }
    }
  }
  gotoProduct(lob_name: any, sub_lob: any, ppl?:any) {

    if (isPlatformBrowser(this.platformId)) {

    localStorage.removeItem("ExploreMappedData")
    localStorage.removeItem("ExploreMappedData1")
    localStorage.removeItem("exploreData")
      localStorage.removeItem("UrlData")
      let lobname = lob_name == 'Icv Trucks' ? 'trucks' : lob_name == 'Buses' ? 'buses-vans' :  lob_name.replace(/\s/g, "-").toLowerCase();
      let sublobname = (sub_lob.replace(/\s/g, "-")).toLowerCase();
      let display_ppl = (ppl.replace(/\s/g, "-")).toLowerCase();
      let currentUrl = `/product-list/` + lobname + `/` + sublobname + `/` + ((display_ppl).replace("---", "-")).replace("--", "-")
      return currentUrl;
    }
    return;
  }
  gotoPath(link: any, product: any){

    localStorage.removeItem("ExploreMappedData")
    localStorage.removeItem("ExploreMappedData1")
    var url = link.replace('category-list','/product-list') + '/' +product
    return url
  }

  breadcrumb(){
    localStorage.removeItem('localBreadCrumb');
    this.breadcrumbdata =[];
    var breadcrumbList1 = {
      label: 'sitemap',
      url: `/sitemap/`
    };
    this.breadcrumbdata.push(breadcrumbList1);
    this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbdata));
    this.showBreadCrumb = true;
  }

  callConfigurator() {
    if (isPlatformBrowser(this.platformId)) {

      if (this.storageService.getUserData()) {
        localStorage.removeItem('VASData')
        localStorage.removeItem('VASDataProfile')
      }
      else {
        localStorage.setItem('previousUrl', '/configurator-home')
      }
    }
  }
  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag("description", null, this.metadesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      this.metatitle
    );
    this.seoservice.updateMetaTag(null, "og:description", this.metadesc);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }



ngOnDestroy() {
    this.sub.unsubscribe();
  }
}

